import React from "react";
import "./LayoutShell.css";

export default function LayoutShell({ active = "dashboard", children }) {
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-logo">CR</div>
        <div className="sidebar-nav">
          <div className={`sidebar-item ${active === "dashboard" ? "active" : ""}`}>
            🏠 Dashboard
          </div>
          <div className={`sidebar-item ${active === "bookings" ? "active" : ""}`}>
            📅 Bookings
          </div>
          <div className={`sidebar-item ${active === "payments" ? "active" : ""}`}>
            💳 Payments
          </div>
          <div className={`sidebar-item ${active === "community" ? "active" : ""}`}>
            🎉 Community
          </div>
          <div className={`sidebar-item ${active === "directory" ? "active" : ""}`}>
            📇 Directory
          </div>
          <div className={`sidebar-item ${active === "helpdesk" ? "active" : ""}`}>
            🛠 Helpdesk
          </div>
          <div className={`sidebar-item ${active === "profile" ? "active" : ""}`}>
            👤 Profile
          </div>
        </div>
      </aside>

      <div className="main">
        <header className="navbar">
          <div className="navbar-title">Resident Dashboard</div>
          <div className="navbar-right">
            <span>Welcome back</span>
            <div className="nav-avatar" />
          </div>
        </header>

        <main className="content">{children}</main>
      </div>
    </div>
  );
}